import { useMutation, useQuery } from "@tanstack/react-query";
import { Download } from "lucide-react";
import { useParams } from "react-router-dom";

import { PageHeader } from "@/components/PageHeader";
import { ExportApi, ProjectsApi } from "@/lib/api";

export function ExportPage() {
  const { projectId } = useParams<{ projectId: string }>();
  const pid = Number(projectId);
  const project = useQuery({
    queryKey: ["project", pid],
    queryFn: () => ProjectsApi.get(pid),
    enabled: Number.isFinite(pid),
  });

  const downloadCvat = useMutation({
    mutationFn: async () => {
      const data = await ExportApi.cvat(pid);
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const stamp = new Date().toISOString().replace(/[:.]/g, "-");
      a.download = `${project.data?.name ?? "project"}_${stamp}_cvat.json`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
  });

  return (
    <>
      <PageHeader
        title="Export"
        subtitle={project.data?.name}
      />
      <div className="max-w-3xl px-4 py-4 md:px-8 md:py-6">
        <div className="card p-4 md:p-6">
          <h3 className="text-sm font-semibold">CVAT JSON</h3>
          <p className="mt-2 text-sm text-text-muted">
            Downloads a JSON file containing all tasks with at least one submitted tagging. Each task carries
            annotations from every user who submitted it.
          </p>
          <button
            type="button"
            className="btn-primary mt-4"
            onClick={() => downloadCvat.mutate()}
            disabled={downloadCvat.isPending}
          >
            <Download size={16} />
            {downloadCvat.isPending ? "Generating…" : "Download CVAT JSON"}
          </button>
          {downloadCvat.isError && (
            <div className="mt-4 rounded-md border border-status-error/40 bg-status-error/10 px-3 py-2 text-sm text-status-error">
              Export failed. Are you the project owner?
            </div>
          )}
        </div>
      </div>
    </>
  );
}
